module.exports = __webpack_public_path__ + "verifyphone-bkg.jpg";